module.exports = __webpack_public_path__ + "img/sample_form_header.1c8fc006.jpg";